// // import React, { useEffect, useCallback } from 'react';

// // import PropTypes from 'prop-types';
// // import CSSModule from 'react-css-modules';
// // import { FormattedMessage, injectIntl } from 'react-intl';
// // import { connect } from 'react-redux';
// // import { toast } from 'react-toastify';

// // import {
// //   Button,
// //   Coupon,
// //   CouponPriceDetails,
// //   Feedback,
// //   Modal,
// //   Spinner,
// // } from 'components';
// // import { USED_COUPON_STATES } from 'coupon-common';
// // import {
// //   actions as couponBuilderActions,
// //   duck as couponBuilderDuck,
// // } from 'coupon-common/src/modules/couponBuilder';
// // import { actions as couponsActivityActions } from 'coupon-common/src/modules/usedCoupons/couponsActivity';
// // import { actions as newUsedCouponsActions } from 'coupon-common/src/modules/usedCoupons/newUsedCoupons';
// // import { dispatchAsAsync } from 'coupon-common/src/utils';

// // import messages from './messages';
// // import styles from './ProcessCoupon.module.scss';
// // import { Form, FormSpy } from 'react-final-form';
// // import CouponPriceFiledGroup from 'containers/CouponPriceFiledGroup/CouponPriceFiledGroup';

// // export const ProcessCoupon = ({
// //   intl,
// //   dispatch,
// //   usedCouponData,
// //   isRootModal,
// //   couponsActivityFetching,
// //   couponsActivityError,
// //   couponsActivityIsModalOpen,
// //   newUsedCouponsIsModalOpen,
// //   couponBuilderState,
// //   businessData,
// //   taxRatesState,
// // }) => {
// //   const isOpen = isRootModal
// //     ? newUsedCouponsIsModalOpen
// //     : couponsActivityIsModalOpen;

// //   useEffect(() => {
// //     if (isOpen) {
// //       dispatch(couponBuilderActions.getCoupon(usedCouponData.coupon));
// //     }
// //   }, [dispatch, isOpen, usedCouponData.coupon]);

// //   const { data: couponData, fetched: couponDataFetched } =
// //     couponBuilderState[usedCouponData.coupon] ||
// //     couponBuilderDuck.INITIAL_COUPON_ITEM_STATE;

// //   const handleProcessCouponClick = async (isAccepted = false, formData) => {
// //     const action = isAccepted
// //       ? couponsActivityActions.acceptCoupon
// //       : couponsActivityActions.rejectCoupon;

// //     const { error, errorNotification } = await dispatchAsAsync(
// //       action(usedCouponData.id, formData),
// //       dispatch,
// //     );

// //     if (!error) {
// //       handleCloseModalClick();

// //       const toastText = isAccepted
// //         ? messages.couponAcceptedNotificationText
// //         : messages.couponRejectedNotificationText;

// //       toast(
// //         <FormattedMessage
// //           {...toastText}
// //           values={{
// //             couponTitle: couponData.title,
// //             b: chunks => <b>{chunks}</b>,
// //           }}
// //         />,
// //       );
// //       return;
// //     }

// //     if (errorNotification) {
// //       handleCloseModalClick();
// //       toast.error(error);
// //     }
// //   };

// //   const handleCloseModalClick = () => {
// //     // TODO: Fast fix, ProcessCoupon and UsedCoupon components should be refactored
// //     // because of too deep integration and hard to understand structure.
// //     dispatch(newUsedCouponsActions.closeModal());
// //     dispatch(couponsActivityActions.closeModal());
// //     dispatch(couponBuilderActions.clearCouponState(usedCouponData.coupon));
// //   };

// //   const usedCouponInWaitingState =
// //     usedCouponData.state === USED_COUPON_STATES.WAITING;
// //   const usedCouponInRejectedState =
// //     usedCouponData.state === USED_COUPON_STATES.REJECTED;

// //   let customersRequestText;

// //   switch (true) {
// //     case usedCouponInWaitingState:
// //       customersRequestText = messages.customersWaitingRequestText;
// //       break;
// //     case usedCouponInRejectedState:
// //       customersRequestText = messages.customersRejectedRequestText;
// //       break;
// //     default:
// //       customersRequestText = messages.customersProcessedRequestText;
// //   }

// //   const validateForm = values => {
// //     if (couponData?.show_price_on_coupon) return null;

// //     if (couponData?.type === 'amount_off') {
// //       if (+(values?.price || 0) - +(couponData?.amount_off || 0) < 0) {
// //         return {
// //           price: intl.formatMessage(messages.priceLessThanDiscountText),
// //         };
// //       }
// //     }
// //   };

// //   const submitForm = values => {
// //     if (!couponData?.show_price_on_coupon) {
// //       if (!values?.price || values?.price <= 0) {
// //         return { price: intl.formatMessage(messages.priceCannotBeEmptyText) };
// //       }
// //       const { price, ...rest } = values; // Added only to support backend
// //       handleProcessCouponClick(true, { ...rest, coupon_total_price: price });
// //     } else {
// //       handleProcessCouponClick(true);
// //     }
// //   };

// //   const initialValues = {
// //     price:
// //       (usedCouponData?.actual_price || 0) > 0
// //         ? usedCouponData?.actual_price
// //         : null,
// //     gst: usedCouponData?.gst || null,
// //     hst: usedCouponData?.hst || null,
// //     rst: usedCouponData?.rst || null,
// //     pst: usedCouponData?.pst || null,
// //     qst: usedCouponData?.qst || null,
// //   };

// //   return (
// //     <Modal
// //       title={intl.formatMessage(messages.blockHeadingText)}
// //       isOpen={isOpen}
// //       onRequestClose={handleCloseModalClick}
// //     >
// //       <div styleName="process-coupon-modal-container">
// //         {couponData && couponDataFetched ? (
// //           <>
// //             <FormattedMessage
// //               tagName="p"
// //               {...customersRequestText}
// //               values={{
// //                 customerName: usedCouponData.customer_name,
// //                 paymentType: usedCouponData.pay_by_points
// //                   ? intl.formatMessage(messages.payByPointsText)
// //                   : intl.formatMessage(messages.payByDollarsText),
// //                 b: chunks => <b>{chunks}</b>,
// //               }}
// //             />
// //             <Coupon data={couponData} businessData={businessData} />
// //             <div styleName="coupon-price-details" className="text-right mt-3">
// //               <Form
// //                 onSubmit={submitForm}
// //                 initialValues={initialValues}
// //                 validate={validateForm}
// //                 render={({ handleSubmit }) => {
// //                   return (
// //                     <>
// //                       <FormSpy
// //                         subscription={{
// //                           values: true,
// //                           form: true,
// //                           dirty: true,
// //                           submitting: true,
// //                         }}
// //                         render={({ values, form, dirty, submitting }) => (
// //                           <>
// //                             {couponData?.show_price_on_coupon ? (
// //                               <CouponPriceDetails data={couponData} />
// //                             ) : (
// //                               <CouponPriceFiledGroup
// //                                 couponData={couponData}
// //                                 couponActionComplete={!usedCouponInWaitingState}
// //                                 usedCouponData={usedCouponData}
// //                                 data={values}
// //                                 form={form}
// //                               />
// //                             )}
// //                           </>
// //                         )}
// //                       />

// //                       {usedCouponInWaitingState && (
// //                         <>
// //                           <hr className="mb-0" />
// //                           {couponsActivityFetching ? (
// //                             <Spinner
// //                               containerClassName="coupon-processing-spinner-container"
// //                               show
// //                             />
// //                           ) : (
// //                             <>
// //                               <Button
// //                                 onClick={() => handleProcessCouponClick()}
// //                                 outline
// //                               >
// //                                 <FormattedMessage
// //                                   {...messages.rejectButtonText}
// //                                 />
// //                               </Button>
// //                               <Button
// //                                 onClick={handleSubmit}
// //                                 className="mr-0"
// //                                 fetching={taxRatesState.fetching}
// //                               >
// //                                 <FormattedMessage
// //                                   {...messages.acceptButtonText}
// //                                 />
// //                               </Button>
// //                             </>
// //                           )}
// //                         </>
// //                       )}
// //                     </>
// //                   );
// //                 }}
// //               />
// //             </div>
// //           </>
// //         ) : (
// //           <Spinner show />
// //         )}
// //         <Feedback
// //           className="mt-3"
// //           show={!!(couponsActivityError && !couponsActivityFetching)}
// //           content={couponsActivityError}
// //           invalid
// //         />
// //       </div>
// //     </Modal>
// //   );
// // };

// // ProcessCoupon.propTypes = {
// //   intl: PropTypes.object,
// //   dispatch: PropTypes.func,
// //   usedCouponData: PropTypes.object,
// //   isRootModal: PropTypes.bool,
// //   couponsActivityFetching: PropTypes.bool,
// //   couponsActivityError: PropTypes.string,
// //   couponsActivityIsModalOpen: PropTypes.bool,
// //   newUsedCouponsIsModalOpen: PropTypes.bool,
// //   couponBuilderState: PropTypes.object,
// //   businessData: PropTypes.object,
// //   taxRatesState: PropTypes.object,
// // };

// // const mapStateToProps = state => ({
// //   couponsActivityFetching: state.usedCoupons.couponsActivity.fetching,
// //   couponsActivityError: state.usedCoupons.couponsActivity.error,
// //   couponsActivityIsModalOpen: state.usedCoupons.couponsActivity.isModalOpen,
// //   couponBuilderState: state.couponBuilder,
// //   newUsedCouponsIsModalOpen: state.usedCoupons.newUsedCoupons.isModalOpen,
// //   businessData: state.businessInfo.data,
// //   taxRatesState: state.taxRates,
// // });

// // export default connect(mapStateToProps)(
// //   injectIntl(CSSModule(ProcessCoupon, styles)),
// // );
// import React, { useEffect } from 'react';
// import PropTypes from 'prop-types';
// import { FormattedMessage, injectIntl } from 'react-intl';
// import { connect } from 'react-redux';
// import { toast } from 'react-toastify';

// import {
//   Button,
//   Coupon,
//   CouponPriceDetails,
//   Feedback,
//   Modal,
//   Spinner,
// } from 'components';
// import { USED_COUPON_STATES } from 'coupon-common';
// import {
//   actions as couponBuilderActions,
//   duck as couponBuilderDuck,
// } from 'coupon-common/src/modules/couponBuilder';
// import { actions as couponsActivityActions } from 'coupon-common/src/modules/usedCoupons/couponsActivity';
// import { actions as newUsedCouponsActions } from 'coupon-common/src/modules/usedCoupons/newUsedCoupons';
// import { dispatchAsAsync } from 'coupon-common/src/utils';

// import messages from './messages';
// import { Form, FormSpy } from 'react-final-form';
// import CouponPriceFiledGroup from 'containers/CouponPriceFiledGroup/CouponPriceFiledGroup';

// export const ProcessCoupon = ({
//   intl,
//   dispatch,
//   usedCouponData,
//   isRootModal,
//   couponsActivityFetching,
//   couponsActivityError,
//   couponsActivityIsModalOpen,
//   newUsedCouponsIsModalOpen,
//   couponBuilderState,
//   businessData,
//   taxRatesState,
// }) => {
//   const isOpen = isRootModal
//     ? newUsedCouponsIsModalOpen
//     : couponsActivityIsModalOpen;

//   useEffect(() => {
//     if (isOpen) {
//       dispatch(couponBuilderActions.getCoupon(usedCouponData.coupon));
//     }
//   }, [dispatch, isOpen, usedCouponData.coupon]);

//   const { data: couponData, fetched: couponDataFetched } =
//     couponBuilderState[usedCouponData.coupon] ||
//     couponBuilderDuck.INITIAL_COUPON_ITEM_STATE;

//   const handleProcessCouponClick = async (isAccepted = false, formData) => {
//     const action = isAccepted
//       ? couponsActivityActions.acceptCoupon
//       : couponsActivityActions.rejectCoupon;

//     const { error, errorNotification } = await dispatchAsAsync(
//       action(usedCouponData.id, formData),
//       dispatch,
//     );

//     if (!error) {
//       handleCloseModalClick();
//       const toastText = isAccepted
//         ? messages.couponAcceptedNotificationText
//         : messages.couponRejectedNotificationText;
//       toast(
//         <FormattedMessage
//           {...toastText}
//           values={{
//             couponTitle: couponData.title,
//             b: chunks => <b>{chunks}</b>,
//           }}
//         />,
//       );
//       return;
//     }

//     if (errorNotification) {
//       handleCloseModalClick();
//       toast.error(error);
//     }
//   };

//   const handleCloseModalClick = () => {
//     dispatch(newUsedCouponsActions.closeModal());
//     dispatch(couponsActivityActions.closeModal());
//     dispatch(couponBuilderActions.clearCouponState(usedCouponData.coupon));
//   };

//   const usedCouponInWaitingState = usedCouponData.state === USED_COUPON_STATES.WAITING;
//   const usedCouponInRejectedState = usedCouponData.state === USED_COUPON_STATES.REJECTED;

//   let customersRequestText;
//   switch (true) {
//     case usedCouponInWaitingState:
//       customersRequestText = messages.customersWaitingRequestText;
//       break;
//     case usedCouponInRejectedState:
//       customersRequestText = messages.customersRejectedRequestText;
//       break;
//     default:
//       customersRequestText = messages.customersProcessedRequestText;
//   }

//   const validateForm = values => {
//     if (couponData?.show_price_on_coupon) return null;
//     if (couponData?.type === 'amount_off') {
//       if (+(values?.price || 0) - +(couponData?.amount_off || 0) < 0) {
//         return { price: intl.formatMessage(messages.priceLessThanDiscountText) };
//       }
//     }
//   };

//   const submitForm = values => {
//     if (!couponData?.show_price_on_coupon) {
//       if (!values?.price || values?.price <= 0) {
//         return { price: intl.formatMessage(messages.priceCannotBeEmptyText) };
//       }
//       const { price, ...rest } = values;
//       handleProcessCouponClick(true, { ...rest, coupon_total_price: price });
//     } else {
//       handleProcessCouponClick(true);
//     }
//   };

//   const initialValues = {
//     price: (usedCouponData?.actual_price || 0) > 0 ? usedCouponData?.actual_price : null,
//     gst: usedCouponData?.gst || null,
//     hst: usedCouponData?.hst || null,
//     rst: usedCouponData?.rst || null,
//     pst: usedCouponData?.pst || null,
//     qst: usedCouponData?.qst || null,
//   };

//   return (
//     <Modal
//       isOpen={isOpen}
//       hideHeader
//       noPadding
//     >
//       {/* ── Two-column layout — fully fits viewport, no scroll ── */}
//       <div style={{
//         display: 'flex',
//         width: '100%',
//         height: '100%',
//         maxWidth: '760px',
//         maxHeight: '90vh',
//         margin: '-1px auto 0',
//         borderRadius: '1rem',
//         overflow: 'hidden',
//         fontFamily: "'Segoe UI', sans-serif",
//       }}>

//         {/* ── LEFT: dark side with coupon ── */}
//         <div style={{
//           width: '44%',
//           flexShrink: 0,
//           background: 'linear-gradient(160deg, #1a0a0a 0%, #2d0c0c 40%, #3d1010 100%)',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           padding: '20px 16px',
//           gap: '16px',
//           position: 'relative',
//           overflow: 'hidden',
//         }}>
//           {/* Radial glow */}
//           <div style={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: '260px',
//             height: '260px',
//             borderRadius: '50%',
//             background: 'radial-gradient(circle, rgba(220,30,30,0.22) 0%, transparent 70%)',
//             pointerEvents: 'none',
//           }} />

//           {/* Coupon */}
//           <div style={{ width: '100%', position: 'relative', zIndex: 1 }}>
//             {couponData && couponDataFetched ? (
//               <Coupon data={couponData} businessData={businessData} />
//             ) : (
//               <div style={{
//                 width: '100%',
//                 height: '180px',
//                 borderRadius: '14px',
//                 background: 'rgba(255,255,255,0.05)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}>
//                 <Spinner show />
//               </div>
//             )}
//           </div>

//           {/* Customer request message */}
//           {couponData && couponDataFetched && (
//             <p style={{
//               color: 'rgba(255,255,255,0.5)',
//               fontSize: '12px',
//               lineHeight: '1.6',
//               margin: 0,
//               textAlign: 'center',
//               position: 'relative',
//               zIndex: 1,
//             }}>
//               <FormattedMessage
//                 {...customersRequestText}
//                 values={{
//                   customerName: usedCouponData.customer_name,
//                   paymentType: usedCouponData.pay_by_points
//                     ? intl.formatMessage(messages.payByPointsText)
//                     : intl.formatMessage(messages.payByDollarsText),
//                   b: chunks => <b style={{ color: 'rgba(255,255,255,0.85)' }}>{chunks}</b>,
//                 }}
//               />
//             </p>
//           )}
//         </div>

//         {/* ── RIGHT: light side — flex column, no scroll ── */}
//         <div style={{
//           width: '56%',
//           background: '#faf5f5',
//           display: 'flex',
//           flexDirection: 'column',
//           padding: '20px 20px 16px',
//           overflow: 'hidden',
//           position: 'relative',
//           minHeight: 0,
//         }}>

//           {/* Close button — top right */}
//           <button
//             onClick={handleCloseModalClick}
//             style={{
//               position: 'absolute',
//               top: '12px',
//               right: '12px',
//               width: '28px',
//               height: '28px',
//               borderRadius: '7px',
//               border: '1.5px solid #e0d0d0',
//               background: 'white',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: '12px',
//               color: '#888',
//               fontWeight: '600',
//               zIndex: 2,
//             }}
//           >
//             ✕
//           </button>

//           {couponData && couponDataFetched ? (
//             <Form
//               onSubmit={submitForm}
//               initialValues={initialValues}
//               validate={validateForm}
//               render={({ handleSubmit }) => (
//                 <div style={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   height: '100%',
//                   gap: '8px',
//                   minHeight: 0,
//                 }}>

//                   {/* Title + subtitle */}
//                   <div style={{ paddingRight: '28px', flexShrink: 0 }}>
//                     <h2 style={{
//                       fontSize: '18px',
//                       fontWeight: '700',
//                       color: '#1a1a1a',
//                       margin: '0 0 5px 0',
//                       lineHeight: '1.3',
//                     }}>
//                       {intl.formatMessage(messages.blockHeadingText)}
//                     </h2>
//                     <p style={{
//                       fontSize: '12px',
//                       color: '#999',
//                       margin: 0,
//                       lineHeight: '1.5',
//                     }}>
//                       {usedCouponData.pay_by_points
//                         ? intl.formatMessage(messages.payByPointsText)
//                         : intl.formatMessage(messages.payByDollarsText)}
//                     </p>
//                   </div>

//                   {/* Divider */}
//                   <div style={{ height: '1px', background: '#ede5e5', flexShrink: 0 }} />

//                   {/* Form fields — no scroll */}
//                   <div style={{ flex: 1, overflow: 'hidden', paddingTop: '4px', minHeight: 0 }}>
//                     <FormSpy
//                       subscription={{ values: true, form: true, dirty: true, submitting: true }}
//                       render={({ values, form }) => (
//                         <>
//                           {couponData?.show_price_on_coupon ? (
//                             <CouponPriceDetails data={couponData} />
//                           ) : (
//                             <CouponPriceFiledGroup
//                               couponData={couponData}
//                               couponActionComplete={!usedCouponInWaitingState}
//                               usedCouponData={usedCouponData}
//                               data={values}
//                               form={form}
//                             />
//                           )}
//                         </>
//                       )}
//                     />
//                   </div>

//                   {/* Action buttons — row aligned, always visible */}
//                   {usedCouponInWaitingState && (
//                     <div style={{ flexShrink: 0 }}>
//                       {couponsActivityFetching ? (
//                         <div style={{ textAlign: 'center', padding: '10px' }}>
//                           <Spinner show />
//                         </div>
//                       ) : (
//                         <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
//                           <button
//                             type="button"
//                             onClick={() => handleProcessCouponClick()}
//                             style={{
//                               flex: 1,
//                               padding: '11px 0',
//                               borderRadius: '30px',
//                               border: '1.5px solid #D4001D',
//                               background: 'transparent',
//                               color: '#D4001D',
//                               fontSize: '13px',
//                               fontWeight: '600',
//                               cursor: 'pointer',
//                             }}
//                           >
//                             <FormattedMessage {...messages.rejectButtonText} />
//                           </button>
//                           <button
//                             type="button"
//                             onClick={handleSubmit}
//                             disabled={taxRatesState?.fetching}
//                             style={{
//                               flex: 1,
//                               padding: '11px 0',
//                               borderRadius: '30px',
//                               border: 'none',
//                               background: 'linear-gradient(135deg, #EF0023, #D4001D)',
//                               color: 'white',
//                               fontSize: '14px',
//                               fontWeight: '700',
//                               cursor: 'pointer',
//                               boxShadow: '0 4px 14px rgba(212,0,29,0.3)',
//                               opacity: taxRatesState?.fetching ? 0.7 : 1,
//                             }}
//                           >
//                             <FormattedMessage {...messages.acceptButtonText} />
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   )}

//                   {/* Error feedback */}
//                   {!!(couponsActivityError && !couponsActivityFetching) && (
//                     <Feedback
//                       show
//                       content={couponsActivityError}
//                       invalid
//                     />
//                   )}
//                 </div>
//               )}
//             />
//           ) : (
//             <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//               <Spinner show />
//             </div>
//           )}
//         </div>
//       </div>
//     </Modal>
//   );
// };

// ProcessCoupon.propTypes = {
//   intl: PropTypes.object,
//   dispatch: PropTypes.func,
//   usedCouponData: PropTypes.object,
//   isRootModal: PropTypes.bool,
//   couponsActivityFetching: PropTypes.bool,
//   couponsActivityError: PropTypes.string,
//   couponsActivityIsModalOpen: PropTypes.bool,
//   newUsedCouponsIsModalOpen: PropTypes.bool,
//   couponBuilderState: PropTypes.object,
//   businessData: PropTypes.object,
//   taxRatesState: PropTypes.object,
// };

// const mapStateToProps = state => ({
//   couponsActivityFetching: state.usedCoupons.couponsActivity.fetching,
//   couponsActivityError: state.usedCoupons.couponsActivity.error,
//   couponsActivityIsModalOpen: state.usedCoupons.couponsActivity.isModalOpen,
//   couponBuilderState: state.couponBuilder,
//   newUsedCouponsIsModalOpen: state.usedCoupons.newUsedCoupons.isModalOpen,
//   businessData: state.businessInfo.data,
//   taxRatesState: state.taxRates,
// });

// export default connect(mapStateToProps)(injectIntl(ProcessCoupon));
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Coupon,
  CouponPriceDetails,
  Feedback,
  Modal,
  Spinner,
} from 'components';
import { USED_COUPON_STATES } from 'coupon-common';
import {
  actions as couponBuilderActions,
  duck as couponBuilderDuck,
} from 'coupon-common/src/modules/couponBuilder';
import { actions as couponsActivityActions } from 'coupon-common/src/modules/usedCoupons/couponsActivity';
import { actions as newUsedCouponsActions } from 'coupon-common/src/modules/usedCoupons/newUsedCoupons';
import { dispatchAsAsync } from 'coupon-common/src/utils';

import messages from './messages';
import { Form, FormSpy } from 'react-final-form';
import CouponPriceFiledGroup from 'containers/CouponPriceFiledGroup/CouponPriceFiledGroup';

/* ── Responsive hook ─────────────────────────────────────────── */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

export const ProcessCoupon = ({
  intl,
  dispatch,
  usedCouponData,
  isRootModal,
  couponsActivityFetching,
  couponsActivityError,
  couponsActivityIsModalOpen,
  newUsedCouponsIsModalOpen,
  couponBuilderState,
  businessData,
  taxRatesState,
}) => {
  const isMobile = useIsMobile();

  const isOpen = isRootModal
    ? newUsedCouponsIsModalOpen
    : couponsActivityIsModalOpen;

  useEffect(() => {
    if (isOpen) {
      dispatch(couponBuilderActions.getCoupon(usedCouponData.coupon));
    }
  }, [dispatch, isOpen, usedCouponData.coupon]);

  const { data: couponData, fetched: couponDataFetched } =
    couponBuilderState[usedCouponData.coupon] ||
    couponBuilderDuck.INITIAL_COUPON_ITEM_STATE;

  const handleProcessCouponClick = async (isAccepted = false, formData) => {
    const action = isAccepted
      ? couponsActivityActions.acceptCoupon
      : couponsActivityActions.rejectCoupon;

    const { error, errorNotification } = await dispatchAsAsync(
      action(usedCouponData.id, formData),
      dispatch,
    );

    if (!error) {
      handleCloseModalClick();
      const toastText = isAccepted
        ? messages.couponAcceptedNotificationText
        : messages.couponRejectedNotificationText;
      toast(
        <FormattedMessage
          {...toastText}
          values={{
            couponTitle: couponData.title,
            b: chunks => <b>{chunks}</b>,
          }}
        />,
      );
      return;
    }
    if (errorNotification) {
      handleCloseModalClick();
      toast.error(error);
    }
  };

  const handleCloseModalClick = () => {
    dispatch(newUsedCouponsActions.closeModal());
    dispatch(couponsActivityActions.closeModal());
    dispatch(couponBuilderActions.clearCouponState(usedCouponData.coupon));
  };

  const usedCouponInWaitingState  = usedCouponData.state === USED_COUPON_STATES.WAITING;
  const usedCouponInRejectedState = usedCouponData.state === USED_COUPON_STATES.REJECTED;

  let customersRequestText;
  switch (true) {
    case usedCouponInWaitingState:
      customersRequestText = messages.customersWaitingRequestText;
      break;
    case usedCouponInRejectedState:
      customersRequestText = messages.customersRejectedRequestText;
      break;
    default:
      customersRequestText = messages.customersProcessedRequestText;
  }

  const validateForm = values => {
    if (couponData?.show_price_on_coupon) return null;
    if (couponData?.type === 'amount_off') {
      if (+(values?.price || 0) - +(couponData?.amount_off || 0) < 0) {
        return { price: intl.formatMessage(messages.priceLessThanDiscountText) };
      }
    }
  };

  const submitForm = values => {
    if (!couponData?.show_price_on_coupon) {
      if (!values?.price || values?.price <= 0) {
        return { price: intl.formatMessage(messages.priceCannotBeEmptyText) };
      }
      const { price, ...rest } = values;
      handleProcessCouponClick(true, { ...rest, coupon_total_price: price });
    } else {
      handleProcessCouponClick(true);
    }
  };

  const initialValues = {
    price: (usedCouponData?.actual_price || 0) > 0 ? usedCouponData?.actual_price : null,
    gst: usedCouponData?.gst || null,
    hst: usedCouponData?.hst || null,
    rst: usedCouponData?.rst || null,
    pst: usedCouponData?.pst || null,
    qst: usedCouponData?.qst || null,
  };

  /* ── navbar height for mobile overlay offset ── */
  const navbarHeight = isMobile
    ? (document.querySelector('nav')?.offsetHeight || 56)
    : 0;

  return (
    <Modal
      isOpen={isOpen}
      hideHeader
      noPadding
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 99,
          ...(isMobile ? {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: `${navbarHeight + 16}px`,
            paddingBottom: '24px',
            overflowY: 'auto',
          } : {}),
        },
        content: isMobile ? {
          position: 'relative',
          inset: 'unset',
          margin: '0 auto',
          padding: 0,
          border: 'none',
          borderRadius: '1rem',
          width: 'calc(100% - 32px)',
          maxWidth: '420px',
          overflow: 'visible',
          background: 'transparent',
          boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
        } : {},
      }}
    >
      {/* ── WRAPPER: row on desktop, column on mobile ── */}
      <div className={isMobile ? 'mt-4' : 'mt-auto'} style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        width: '100%',
        maxWidth: isMobile ? '100%' : '760px',
        maxHeight: isMobile ? 'none' : '90vh',
        
        borderRadius: '1rem',
        overflow: isMobile ? 'visible' : 'hidden',
        fontFamily: "'Segoe UI', sans-serif",
        boxShadow: isMobile ? 'none' : '0 8px 32px rgba(0,0,0,0.2)',
      }}>

        {/* ════════════════════════════════════════════════
            TOP (mobile) / LEFT (desktop) — dark coupon panel
        ════════════════════════════════════════════════ */}
        <div style={{
          width: isMobile ? '100%' : '44%',
          flexShrink: 0,
          background: 'linear-gradient(160deg, #1a0a0a 0%, #2d0c0c 40%, #3d1010 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? '28px 20px 20px' : '20px 16px',
          gap: '12px',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: isMobile ? '1rem 1rem 0 0' : '1rem 0 0 1rem',
        }}>
          {/* Radial glow */}
          <div style={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%,-50%)',
            width: '260px', height: '260px', borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(220,30,30,0.22) 0%, transparent 70%)',
            pointerEvents: 'none',
          }} />

          {/* Coupon */}
          <div style={{ width: '100%', position: 'relative', zIndex: 1 }}>
            {couponData && couponDataFetched ? (
              <Coupon data={couponData} businessData={businessData} />
            ) : (
              <div style={{
                width: '100%', height: '180px', borderRadius: '14px',
                background: 'rgba(255,255,255,0.05)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <Spinner show />
              </div>
            )}
          </div>

          {/* Customer message */}
          {couponData && couponDataFetched && (
            <p style={{
              color: 'rgba(255,255,255,0.5)', fontSize: '12px',
              lineHeight: '1.6', margin: 0,
              textAlign: 'center', position: 'relative', zIndex: 1,
            }}>
              <FormattedMessage
                {...customersRequestText}
                values={{
                  customerName: usedCouponData.customer_name,
                  paymentType: usedCouponData.pay_by_points
                    ? intl.formatMessage(messages.payByPointsText)
                    : intl.formatMessage(messages.payByDollarsText),
                  b: chunks => <b style={{ color: 'rgba(255,255,255,0.85)' }}>{chunks}</b>,
                }}
              />
            </p>
          )}
        </div>

        {/* ════════════════════════════════════════════════
            BOTTOM (mobile) / RIGHT (desktop) — light form panel
        ════════════════════════════════════════════════ */}
        <div style={{
          width: isMobile ? '100%' : '56%',
          background: '#faf5f5',
          display: 'flex',
          flexDirection: 'column',
          padding: isMobile ? '20px 20px 24px' : '20px 20px 16px',
          position: 'relative',
          overflowY: isMobile ? 'visible' : 'auto',
          minHeight: 0,
          borderRadius: isMobile ? '0 0 1rem 1rem' : '0 1rem 1rem 0',
        }}>

          {/* Close button */}
          <button
            onClick={handleCloseModalClick}
            style={{
              position: 'absolute', top: '12px', right: '12px',
              width: '28px', height: '28px', borderRadius: '7px',
              border: '1.5px solid #e0d0d0', background: 'white',
              cursor: 'pointer', display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: '12px',
              color: '#888', fontWeight: '600', zIndex: 2,
            }}
          >
            ✕
          </button>

          {couponData && couponDataFetched ? (
            <Form
              onSubmit={submitForm}
              initialValues={initialValues}
              validate={validateForm}
              render={({ handleSubmit }) => (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: '8px', minHeight: 0 }}>

                  {/* Title */}
                  <div style={{ paddingRight: '28px', flexShrink: 0 }}>
                    <h2 style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 4px', lineHeight: '1.3' }}>
                      {intl.formatMessage(messages.blockHeadingText)}
                    </h2>
                    <p style={{ fontSize: '12px', color: '#999', margin: 0, lineHeight: '1.5' }}>
                      {usedCouponData.pay_by_points
                        ? intl.formatMessage(messages.payByPointsText)
                        : intl.formatMessage(messages.payByDollarsText)}
                    </p>
                  </div>

                  {/* Divider */}
                  <div style={{ height: '1px', background: '#ede5e5', flexShrink: 0 }} />

                  {/* Form fields */}
                  <div style={{ flex: 1, paddingTop: '4px', minHeight: 0, overflow: isMobile ? 'visible' : 'hidden' }}>
                    <FormSpy
                      subscription={{ values: true, form: true, dirty: true, submitting: true }}
                      render={({ values, form }) => (
                        <>
                          {couponData?.show_price_on_coupon ? (
                            <CouponPriceDetails data={couponData} />
                          ) : (
                            <CouponPriceFiledGroup
                              couponData={couponData}
                              couponActionComplete={!usedCouponInWaitingState}
                              usedCouponData={usedCouponData}
                              data={values}
                              form={form}
                            />
                          )}
                        </>
                      )}
                    />
                  </div>

                  {/* Action buttons */}
                  {usedCouponInWaitingState && (
                    <div style={{ flexShrink: 0, paddingTop: '8px' }}>
                      {couponsActivityFetching ? (
                        <div style={{ textAlign: 'center', padding: '10px' }}>
                          <Spinner show />
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button
                            type="button"
                            onClick={() => handleProcessCouponClick()}
                            style={{
                              flex: 1, padding: '11px 0', borderRadius: '30px',
                              border: '1.5px solid #D4001D', background: 'transparent',
                              color: '#D4001D', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
                            }}
                          >
                            <FormattedMessage {...messages.rejectButtonText} />
                          </button>
                          <button
                            type="button"
                            onClick={handleSubmit}
                            disabled={taxRatesState?.fetching}
                            style={{
                              flex: 1, padding: '11px 0', borderRadius: '30px',
                              border: 'none',
                              background: 'linear-gradient(135deg, #EF0023, #D4001D)',
                              color: 'white', fontSize: '14px', fontWeight: '700',
                              cursor: 'pointer',
                              boxShadow: '0 4px 14px rgba(212,0,29,0.3)',
                              opacity: taxRatesState?.fetching ? 0.7 : 1,
                            }}
                          >
                            <FormattedMessage {...messages.acceptButtonText} />
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Error */}
                  {!!(couponsActivityError && !couponsActivityFetching) && (
                    <Feedback show content={couponsActivityError} invalid />
                  )}

                </div>
              )}
            />
          ) : (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Spinner show />
            </div>
          )}
        </div>

      </div>
    </Modal>
  );
};

ProcessCoupon.propTypes = {
  intl: PropTypes.object,
  dispatch: PropTypes.func,
  usedCouponData: PropTypes.object,
  isRootModal: PropTypes.bool,
  couponsActivityFetching: PropTypes.bool,
  couponsActivityError: PropTypes.string,
  couponsActivityIsModalOpen: PropTypes.bool,
  newUsedCouponsIsModalOpen: PropTypes.bool,
  couponBuilderState: PropTypes.object,
  businessData: PropTypes.object,
  taxRatesState: PropTypes.object,
};

const mapStateToProps = state => ({
  couponsActivityFetching: state.usedCoupons.couponsActivity.fetching,
  couponsActivityError: state.usedCoupons.couponsActivity.error,
  couponsActivityIsModalOpen: state.usedCoupons.couponsActivity.isModalOpen,
  couponBuilderState: state.couponBuilder,
  newUsedCouponsIsModalOpen: state.usedCoupons.newUsedCoupons.isModalOpen,
  businessData: state.businessInfo.data,
  taxRatesState: state.taxRates,
});

export default connect(mapStateToProps)(injectIntl(ProcessCoupon));